import React from "react";
import {
  Box,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";

function Step2Contacts({ formData, errors, handleChange }) {
  return (
    <Box>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            mb: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          Quasi fatto! 🎉
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Inserisci i tuoi dati per ricevere le migliori offerte
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="body2"
            sx={{ mb: 1, fontWeight: 500, color: "text.primary" }}
          >
            Nome{" "}
            <Box component="span" sx={{ color: "error.main" }}>
              *
            </Box>
          </Typography>
          <TextField
            fullWidth
            placeholder="Il tuo nome"
            value={formData.nome}
            onChange={(e) => handleChange("nome", e.target.value)}
            error={errors.nome}
            helperText={errors.nome ? "Inserisci il tuo nome" : ""}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonRoundedIcon sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography
            variant="body2"
            sx={{ mb: 1, fontWeight: 500, color: "text.primary" }}
          >
            Cognome{" "}
            <Box component="span" sx={{ color: "error.main" }}>
              *
            </Box>
          </Typography>
          <TextField
            fullWidth
            placeholder="Il tuo cognome"
            value={formData.cognome}
            onChange={(e) => handleChange("cognome", e.target.value)}
            error={errors.cognome}
            helperText={errors.cognome ? "Inserisci il tuo cognome" : ""}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonRoundedIcon sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography
            variant="body2"
            sx={{ mb: 1, fontWeight: 500, color: "text.primary" }}
          >
            Telefono cellulare{" "}
            <Box component="span" sx={{ color: "error.main" }}>
              *
            </Box>
          </Typography>
          <TextField
            fullWidth
            placeholder="3XX XXX XXXX"
            value={formData.telefono}
            onChange={(e) => handleChange("telefono", e.target.value)}
            error={errors.telefono}
            helperText={
              errors.telefono
                ? "Inserisci il numero di telefono"
                : "Ti contatteremo per proporti le migliori offerte"
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PhoneRoundedIcon sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography
            variant="body2"
            sx={{ mb: 1, fontWeight: 500, color: "text.primary" }}
          >
            Indirizzo email{" "}
            <Box component="span" sx={{ color: "error.main" }}>
              *
            </Box>
          </Typography>
          <TextField
            fullWidth
            type="email"
            placeholder="mario.rossi@email.com"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
            error={errors.email}
            helperText={errors.email ? "Inserisci la tua email" : ""}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailRoundedIcon sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>

      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          bgcolor: "success.lighter",
          borderRadius: 2,
          border: 1,
          borderColor: "success.light",
          mt: 3,
        }}
      >
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              bgcolor: "success.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <ShieldRoundedIcon sx={{ color: "white", fontSize: 24 }} />
          </Box>
          <Box>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, mb: 0.5, color: "success.dark" }}
            >
              I tuoi dati sono al sicuro
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Non vendiamo mai le tue informazioni a terzi
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}

export default Step2Contacts;
